module.exports = __webpack_public_path__ + "img/house.4de8421c.png";